import * as go from 'gojs';

import {
  INITIAL_LAYOUT_TRANSACTION,
  INITIAL_LAYOUT_TRANSACTION_NAME,
  transactionsToSkipProjectDiagramUpdate,
} from 'src/containers/ProjectDiagram/constants/transactions';

/**
 * Whether a finished model transaction represents a genuine content change that
 * should be dispatched to Redux — as opposed to auto-layout or a visual-only
 * transaction (highlight, selection, collaboration sync). Shared by the diagram
 * and headless model-change listeners so their dispatch policy can't drift.
 */
export const shouldDispatchModelChange = (
  e: go.ChangedEvent
): e is go.ChangedEvent & { model: go.Model } =>
  !!e.model &&
  e.isTransactionFinished &&
  e.oldValue !== INITIAL_LAYOUT_TRANSACTION &&
  e.oldValue !== INITIAL_LAYOUT_TRANSACTION_NAME &&
  !transactionsToSkipProjectDiagramUpdate.has(e.oldValue);
